// @ts-strict-ignore
import invoke from 'lodash/invoke';
import { EventsApiTypesMap } from '@usealloy/typegen';
import { snakeToCaps } from '../formatting';
import { ONGOING_ALERTS_REBRAND } from '~/constants';


export function getApplicationTypeFromToken(token: string, alertGenerationInJourneys) {
  const parts = invoke(token, 'split', '-');
  const prefix = parts ? parts[0] : '';

  switch (prefix) {
    case 'L':
    case 'S':
      return 'Evaluation';
    case 'E':
    case 'P':
    case 'B':
      return 'Entity';
    case 'G':
      return 'Group';
    case 'R':
      return 'Review';
    case 'D':
      return 'Document';
    case 'I':
      return 'Entity List';
    case 'TB':
      return 'Batch';
    case 'C':
      return 'Case';
    case 'JA':
      return alertGenerationInJourneys ? `Journey ${snakeToCaps(ONGOING_ALERTS_REBRAND.APPLICATION)}` : 'Journey Application';
    default:
      return '';
  }
}

export function getAlertEventType(eventType: string) {
  if (eventType === EventsApiTypesMap.ENTITY_GROUP_MEMBERS_UPSERTED) {
    return 'business_registry_updated';
  }
  return eventType;
}
